import { Component, OnInit } from '@angular/core';
import { ModuleTestService } from 'src/app/pages/virtual-class/children/services/module-test.service';
import { Plan, TestItem } from 'src/app/pages/virtual-class/interfaces';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-finished-tests',
  templateUrl: './finished-tests.component.html',
  styleUrls: ['./finished-tests.component.scss'],
})
export class FinishedTestsComponent implements OnInit {
  public finishedTests: any[] = [];
  public plans: Plan[] = [];
  public totalPages = 1;

  public initialFilters = {
    search: '',
    planId: '',
    status: '',
    pag: 1,
  };

  constructor(
    private httpSv: HttpService,
    private moduleTestSv: ModuleTestService
  ) {}

  async ngOnInit() {
    const res: any = await this.httpSv.itemIndex('subscription', '', {});
    this.plans = res.data;
    await this.getTests();
  }

  async getTests() {
    const resTest: any = await this.httpSv.itemIndex(
      'learning',
      '',
      this.initialFilters,
      'response'
    );
    const data = resTest.data;
    this.totalPages = data.meta.last_page;
    this.finishedTests = data.data;
  }

  showTestId(id: TestItem['id']) {
    this.moduleTestSv.emitTestId$.emit(id);
  }

  async setPlan(ev: Event) {
    const planId = (ev.target as HTMLIonSelectElement).value;
    this.initialFilters.planId = planId;
    this.initialFilters.pag = 1;
    await this.getTests();
  }

  async setStatus(ev: Event) {
    const status = (ev.target as HTMLIonSelectElement).value;
    this.initialFilters.status = status;
    this.initialFilters.pag = 1;
    await this.getTests();
  }

  async setSearch(ev: Event) {
    const event = ev.target as HTMLIonSearchbarElement;
    this.initialFilters.search = event.value;
    this.initialFilters.pag = 1;
    await this.getTests();
  }

  changePage(page) {
    this.initialFilters.pag = page;
    this.getTests();
  }
}
